/**
 * The one card-link rule this client still has to state.
 *
 * Everything about *how* to link a card is the gateway's now. Its system prompt tells the agent to
 * link every card it names, to target the `cardLinkUrl` the tools return, never to assemble a Coast
 * URL or use an id it did not read from tool output, and how a repeated card and a table row should
 * be handled. The panel used to restate a trimmed version of that here; it is gone, because a second
 * copy of a rule the backend already owns is paid for out of the same prompt budget as the user's
 * own question and drifts from the original the moment the backend changes its mind.
 *
 * What is left is the opposite instruction, which no server-side prompt can reach: the surfaces
 * where a link is pointless.
 */

/**
 * For surfaces where a link is pointless: the summary widgets answer about the card or subform the
 * user is already looking at, so a link would only ever point back at the open context. Said
 * explicitly rather than by omission because the gateway's system prompt asks for a link on every
 * card the agent names.
 */
export function noCardLinkDirective(): string {
  return (
    'Do not include links of any kind. The user is already looking at the record you are ' +
    'summarizing, so name cards in plain text.'
  );
}
